import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'flex-start',
    },
    column: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      flex: '1',

      '& + &': {
        marginLeft: theme.spacing(8),
      },
    },
    title: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1.5),
    },
    wrapperAge: {
      height: 110,
    },
    wrapperGender: {
      height: 110,
    },
  }),
  { name: 'Histograms' }
);
